'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const TickIncrementCalculator=require('../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');
const Formatters=require('../../../../dist-es6/client/formatters');

function _formatterFor(increment){
if(increment.interval==='hours'||
increment.interval==='days'){
return Formatters.localAxisTimeLabel;
}
return()=>'';
}let

TimeAxisLabelDirective=class TimeAxisLabelDirective extends BaseControllerBackedDirective{
get objectBindings(){return['axis']}
get controller(){return TimeAxisLabelDirectiveController}};let


TimeAxisLabelDirectiveController=class TimeAxisLabelDirectiveController extends BaseResizableDirectiveController{
static get $inject(){return['$scope','$element','$window']}

constructor($scope,$element,$window){
super($scope,$element,$window);
this._tickIncrementCalculator=new TickIncrementCalculator;
this._svgElement=null;

$scope.$watch('controller.axis.scale',()=>this._render());
$scope.$watch('controller.dimensions.width',()=>this._render());
}

_render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.axis)||!_.exists(this.axis.scale)){
return;
}

this._refreshSvg();

let spaceBetweenMinorTicks=80;
let idealMinorTicks=this.dimensions.width/spaceBetweenMinorTicks;
let tickIncrements=this._tickIncrementCalculator.calculate(this.axis.domain.duration,idealMinorTicks);

let xAxisGroup=d3.select(this._svgElement).append('g').attr({
class:'x-axis',
transform:`translate(0, ${this.dimensions.height})`}).
call(this._drawTimeAxis(tickIncrements.major));

xAxisGroup.
selectAll('line').
data(this.axis.scale.ticks(d3.time[tickIncrements.minor.interval],tickIncrements.minor.step),_.identity).
enter().
append('line').
attr({
class:'minor',
y1:0,
y2:-3,
x1:this.axis.scale,
x2:this.axis.scale});


xAxisGroup.
selectAll('text').
style({
"text-anchor":'start'});

}

_drawTimeAxis(majorTickIncrement){
return d3.svg.axis().
scale(this.axis.scale).
orient('top').
ticks(d3.time[majorTickIncrement.interval],majorTickIncrement.step).
innerTickSize(7).
outerTickSize(1).
tickFormat(_formatterFor(majorTickIncrement));
}

_refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
}};


module.exports=TimeAxisLabelDirective;
//# sourceMappingURL=timeAxisLabelDirective.js.map
